import { __assign } from "tslib";
import { useMemo } from 'react';
import { useScrollHeight } from '@mercell/use-scroll-height-react-hook';
export var getAccordionAriaProps = function (id, expanded) { return ({
    trigger: {
        id: id,
        'aria-controls': "".concat(id, "-accordion"),
        'data-role': 'summary',
        'aria-expanded': expanded,
    },
    panel: {
        id: "".concat(id, "-accordion"),
        role: 'region',
        'aria-labelledby': id,
    },
}); };
export var useAccordionProps = function (id, isExpanded) {
    var _a = useScrollHeight(isExpanded), scrollHeight = _a.scrollHeight, ref = _a.ref;
    var _b = useMemo(function () { return getAccordionAriaProps(id, isExpanded); }, [id, isExpanded]), trigger = _b.trigger, panel = _b.panel;
    return {
        trigger: trigger,
        panel: __assign(__assign({}, panel), { ref: ref, style: {
                visibility: isExpanded ? 'visible' : 'hidden',
                height: scrollHeight,
            } }),
    };
};
